import React, { useState } from 'react';
import styled from 'styled-components/macro';
import queryString from 'query-string';
import { RouteComponentProps } from 'react-router-dom';
import { FormikHelpers } from 'formik';
import { Tables, Button } from '@deeptrue-frontend/ui';
import { AssetType } from 'store/modules/assets/assets.types';
import { ReactComponent as Link } from 'assets/icons/link.svg';
import { ReactComponent as Trash } from 'assets/icons/trash.svg';
import RemoveModal from 'components/PromptModal/PromptModal';
import { useFormatMessage } from 'components/IntlProvider';
import Forms from 'components/Forms';
import { FormValues } from 'components/Forms/AssetsDetails';
import ROUTES from 'consts/routing';
import api from 'api/api';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import { translateFieldErrors } from 'components/IntlProvider/translateFieldErrors';

const { withRouter } = RouterProvider;
const { TableRow, TableCell } = Tables;

const StyledImg = styled.img`
  height: 3rem;
  width: 5.25rem;
`;

const ButtonCell = styled(TableCell)`
  text-align: right !important;
  width: 200px;
`;
const AssetPreviewCell = styled(TableCell)`
  width: 10rem;
`;

const SmallCell = styled(TableCell)`
  width: 50px;
`;

interface Props extends RouteComponentProps {
  asset: AssetType;
  removeAsset: (uuid: string) => void;
}

const Asset = ({ asset, removeAsset, history, location }: Props) => {
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const isImgTypeAsset = asset.asset.includes('.jpg');
  const parsedSearch = queryString.parse(location.search);
  const t = useFormatMessage();

  const updateAsset = (
    values: FormValues,
    { setErrors }: FormikHelpers<FormValues>
  ) => {
    api.resources
      .updateAssets({ uuid: asset.uuid, values })
      .then(() => {
        setIsDetailOpen(false);
        const redirectUrl =
          parsedSearch.offset && !Array.isArray(parsedSearch.offset)
            ? `${ROUTES.ADMIN.ASSETS.LIST}?limit=20&offset=${parsedSearch.offset}&action=asset_updated`
            : `${ROUTES.ADMIN.ASSETS.LIST}?action=asset_updated`;

        history.push(redirectUrl);
      })
      .catch((err) => {
        setErrors(
          translateFieldErrors({
            t,
            err: err.response.data,
          })
        );

        setIsDetailOpen(false);
      });
  };
  return (
    <>
      <Forms.AssetDetails
        initialValues={{
          name: asset.name || '',
          context_name: asset.context_name || '',
          is_global: asset.is_global,
        }}
        updateAsset={updateAsset}
        assetDetails={asset}
        isVisible={isDetailOpen}
        onClose={() => setIsDetailOpen(false)}
      />
      <TableRow>
        <AssetPreviewCell>
          <StyledImg src={isImgTypeAsset ? asset.asset : asset.thumbnail_url} />
        </AssetPreviewCell>
        <TableCell>{asset.name}</TableCell>
        <SmallCell>{asset.language}</SmallCell>
        <SmallCell>
          <a
            href={asset.links.original}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Link width="1rem" />
          </a>
        </SmallCell>
        <SmallCell>
          <RemoveModal
            onConfirm={() => removeAsset(asset.uuid)}
            renderer={({ handleOpen }: { handleOpen: any }) => (
              <Trash onClick={handleOpen} />
            )}
          >
            <>
              {t(
                'pages.assets.modal.remove',
                'Are you sure you want to remove asset { name }',
                {
                  name: asset.name,
                }
              )}
            </>
          </RemoveModal>
        </SmallCell>
        <ButtonCell>
          <Button onClick={() => setIsDetailOpen(true)} variant="outlined">
            {t('admin.assets.details', 'Details')}
          </Button>
        </ButtonCell>
      </TableRow>
    </>
  );
};

export default withRouter(Asset);
